/* sds-pack-sync-v1: keeps bundle "Pack" labels in sync on every page and groups bundle lines in the UpCart drawer */
(function () {
  if (window.__sdsPackSync) return;
  window.__sdsPackSync = true;

  var BUILDER = '/products/build-your-own-10-pack';
  var ON_CART_PAGE = /^\/cart\/?$/.test(location.pathname);
  var CART_WRITE = /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);

  function api(url, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }

  function packId(item) {
    return (item && item.properties && item.properties._pack_id) || '';
  }

  function packCounts(cart) {
    var counts = {};
    cart.items.forEach(function (it) {
      var pid = packId(it);
      if (pid) counts[pid] = (counts[pid] || 0) + it.quantity;
    });
    return counts;
  }

  function refreshDrawer() {
    if (typeof window.upcartRefreshCart === 'function') {
      try { window.upcartRefreshCart(); } catch (e) {}
    }
  }

  /* ---------- Pack label sync ---------- */
  var relabeling = false;
  var relabelAgain = false;
  var relabelTimer = 0;

  function scheduleRelabel() {
    if (ON_CART_PAGE) return;
    clearTimeout(relabelTimer);
    relabelTimer = setTimeout(relabel, 450);
  }

  function relabel() {
    if (relabeling) { relabelAgain = true; return; }
    relabeling = true;
    var changed = 0;
    var step = function (n) {
      if (n > 60) return Promise.resolve();
      return api('/cart.js').then(function (cart) {
        cartCache = cart;
        var counts = packCounts(cart);
        var hit = null, label = '';
        cart.items.some(function (it) {
          var pid = packId(it);
          if (!pid) return false;
          label = 'Custom ' + counts[pid] + '-Pack #' + pid;
          if (it.properties.Pack !== label) { hit = it; return true; }
          return false;
        });
        if (!hit) return;
        changed++;
        var props = Object.assign({}, hit.properties, { Pack: label });
        return api('/cart/change.js', { id: hit.key, quantity: hit.quantity, properties: props })
          .then(function () { return step(n + 1); });
      });
    };
    step(0).catch(function () {}).then(function () {
      relabeling = false;
      if (changed) { cartCache = null; refreshDrawer(); }
      if (relabelAgain) { relabelAgain = false; scheduleRelabel(); }
    });
  }

  function onCartWrite(url) {
    if (url && CART_WRITE.test(url)) {
      cartCache = null;
      scheduleRelabel();
    }
  }

  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_WRITE.test(url)) p.then(function () { onCartWrite(url); }, function () {});
    } catch (e) {}
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var u = String(url || '');
    if (CART_WRITE.test(u)) this.addEventListener('loadend', function () { onCartWrite(u); });
    return xOpen.apply(this, arguments);
  };

  /* ---------- Drawer bundle cards ---------- */
  var cartCache = null;
  var expanded = {};
  var armed = {};
  var observer = null;
  var observedRoot = null;
  var renderTimer = 0;

  var CSS = [
    '[data-sds-hide]{display:none !important}',
    '.sds-dpack{--n:#14284b;--g:#ffc233;--gr:#1d7a44;margin:4px 16px 12px;width:auto;box-sizing:border-box;padding:14px;border:2px solid var(--n);border-radius:12px;background:#fff;color:var(--n);font:inherit}',
    '.sds-dpack__top{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}',
    '.sds-dpack__tag{display:inline-block;padding:2px 8px;border-radius:4px;background:var(--g);color:var(--n);font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}',
    '.sds-dpack__title{margin:6px 0 0;font-size:17px;line-height:1.2;font-weight:700;text-transform:uppercase;color:var(--n)}',
    '.sds-dpack__meta{margin:2px 0 0;font-size:13px;line-height:1.4;color:#3d4a63}',
    '.sds-dpack__price{display:flex;flex-direction:column;align-items:flex-end;flex-shrink:0;line-height:1.2}',
    '.sds-dpack__price s{font-size:13px;color:#5b6478}',
    '.sds-dpack__price strong{font-size:18px;color:var(--n)}',
    '.sds-dpack__save{font-size:12px;font-weight:700;color:var(--gr)}',
    '.sds-dpack__thumbs{display:flex;flex-wrap:wrap;align-items:center;gap:4px;margin:10px 0 0;padding:0;list-style:none}',
    '.sds-dpack__thumbs li{position:relative;width:38px;height:38px;border-radius:6px;overflow:hidden;background:#eef0f4;border:1px solid rgba(20,40,75,.15)}',
    '.sds-dpack__thumbs img{display:block;width:100%;height:100%;object-fit:cover}',
    '.sds-dpack__thumbs .sds-dpack__qty{position:absolute;right:0;bottom:0;padding:0 3px;background:var(--n);color:#fff;font-size:10px;line-height:14px;border-top-left-radius:4px}',
    '.sds-dpack__thumbs .sds-dpack__more{display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:var(--n);background:#fff}',
    '.sds-dpack__acts{display:flex;flex-wrap:wrap;align-items:center;gap:6px 16px;margin-top:12px;padding-top:10px;border-top:1px solid rgba(20,40,75,.14)}',
    '.sds-dpack__acts a,.sds-dpack__acts button{min-height:28px;padding:0;border:0;background:none;color:var(--n);font:inherit;font-size:14px;font-weight:600;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
    '.sds-dpack__acts button[data-sds-remove]{margin-left:auto}',
    '.sds-dpack__acts button[data-armed]{color:#a4161a}',
    '.sds-dpack__acts a:focus-visible,.sds-dpack__acts button:focus-visible{outline:2px solid var(--n);outline-offset:2px;border-radius:2px}',
    '[data-sds-pack-row][data-sds-open]{border-left:3px solid #ffc233;padding-left:8px}',
    '.sds-dfee{display:flex;flex-direction:column;gap:2px;margin:8px 0 4px;padding:6px 10px;border-radius:6px;background:#fbf1dc;color:#14284b;font:inherit;font-size:14px;line-height:1.35}',
    '.sds-dfee__row{display:flex;justify-content:space-between;gap:10px}',
    '.sds-dfee__row span:last-child{flex-shrink:0;white-space:nowrap}',
    '.sds-dfee__total{font-weight:700}'
  ].join('');

  function root() {
    var h = document.getElementById('upCart');
    return h && h.shadowRoot;
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function thumb(url) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
  }

  function clearAll(r) {
    r.querySelectorAll('.sds-dpack').forEach(function (n) { n.remove(); });
    r.querySelectorAll('[data-sds-pack-row]').forEach(function (n) {
      n.removeAttribute('data-sds-hide');
      n.removeAttribute('data-sds-pack-row');
      n.removeAttribute('data-sds-open');
    });
    clearFees(r);
  }

  /* ---------- Drawer printing fees (sds-dfee-v1) ---------- */
  var FEE_HANDLE = 'custom-printing-fee';
  var IMG_RE = /\.(png|jpe?g|webp)(\?|#|$)/i;

  function isFee(it) {
    return !!it && (it.handle === FEE_HANDLE || !!(it.properties && it.properties._print_fee_for));
  }

  function propImage(it) {
    var props = (it && it.properties) || {};
    for (var k in props) {
      var v = String(props[k] == null ? '' : props[k]);
      if ((v.indexOf('http') !== -1 || v.indexOf('//') !== -1) && IMG_RE.test(v)) return v;
    }
    return '';
  }

  /* Same matching rules as the /cart page (main-cart-items.liquid): link by
     _print_fee_for (line key, variant id or any property value), else by the
     "For" label = product title + " - " + variant title. Design breaks ties. */
  function pairFees(cart) {
    var shirts = cart.items.filter(function (it) { return !isFee(it); });
    var pairs = {};
    cart.items.forEach(function (f) {
      if (!isFee(f)) return;
      var props = f.properties || {};
      var link = String(props._print_fee_for || '');
      var label = String(props.For || '');
      var design = String(props.Design || '');
      var best = null, bestScore = 0;
      shirts.forEach(function (s) {
        var sp = s.properties || {};
        var score = 0;
        if (link && (link === s.key || link === String(s.variant_id))) score = 4;
        else if (link && Object.keys(sp).some(function (k) { return String(sp[k]) === link; })) score = 4;
        else if (label && label === s.product_title + ' - ' + s.variant_title) score = 2;
        if (!score) return;
        if (design && String(sp.Design || '') === design) score += 1;
        if (pairs[s.key]) score -= 0.5;
        if (score > bestScore) { best = s; bestScore = score; }
      });
      if (best) (pairs[best.key] = pairs[best.key] || []).push(f);
    });
    return pairs;
  }

  function clearFees(r) {
    r.querySelectorAll('.sds-dfee').forEach(function (n) { n.remove(); });
    r.querySelectorAll('[data-sds-fee-row]').forEach(function (n) {
      n.removeAttribute('data-sds-hide');
      n.removeAttribute('data-sds-fee-row');
    });
    r.querySelectorAll('img[data-sds-orig-src]').forEach(function (img) {
      img.setAttribute('src', img.getAttribute('data-sds-orig-src'));
      var ss = img.getAttribute('data-sds-orig-srcset');
      if (ss) img.setAttribute('srcset', ss);
      img.removeAttribute('data-sds-orig-src');
      img.removeAttribute('data-sds-orig-srcset');
    });
  }

  function feeAnchor(row) {
    var qty = row.querySelector('input[type="number"], input[name*="quantity" i], [class*="quantity" i]');
    var labels = Array.prototype.filter.call(row.querySelectorAll('*'), function (el) {
      return !el.children.length && /^\s*(Design|Color|Colour|Size|Style)\s*:/.test(el.textContent || '');
    });
    var el = labels.length ? labels[labels.length - 1] : null;
    if (el && qty) {
      while (el.parentElement && el.parentElement !== row && !el.parentElement.contains(qty)) el = el.parentElement;
      if (el.parentElement && el.parentElement.contains(qty)) return { node: el, after: true };
    }
    if (qty) {
      var q = qty;
      while (q.parentElement && q.parentElement !== row && q.parentElement.querySelectorAll('img').length === 0) q = q.parentElement;
      return { node: q, after: false };
    }
    return null;
  }

  function feeHtml(shirt, fees, currency) {
    var feeTotal = 0;
    var rows = fees.map(function (f) {
      feeTotal += f.final_line_price;
      var d = String((f.properties && f.properties.Design) || '');
      var name = 'Custom printing' + (d && d !== 'Untitled Design' ? ': ' + esc(d) : '') + (f.quantity > 1 ? ' &times; ' + f.quantity : '');
      return '<span class="sds-dfee__row"><span>' + name + '</span><span>+' + money(f.final_line_price, currency) + '</span></span>';
    }).join('');
    return rows + '<span class="sds-dfee__row sds-dfee__total"><span>Item total</span><span>' +
      money(shirt.final_line_price + feeTotal, currency) + '</span></span>';
  }

  function drawFees(r, rows, cart, byKey) {
    var pairs = pairFees(cart);
    var paired = {};
    Object.keys(pairs).forEach(function (k) { pairs[k].forEach(function (f) { paired[f.key] = true; }); });

    rows.forEach(function (row) {
      var it = byKey[row.id];
      if (!it) return;

      if (isFee(it)) {
        if (paired[it.key]) { row.setAttribute('data-sds-hide', ''); row.setAttribute('data-sds-fee-row', ''); }
        else if (row.hasAttribute('data-sds-fee-row')) { row.removeAttribute('data-sds-hide'); row.removeAttribute('data-sds-fee-row'); }
        return;
      }

      var fees = pairs[it.key] || [];
      var mock = propImage(it);
      if (!mock) fees.some(function (f) { mock = propImage(f); return !!mock; });
      var img = row.querySelector('img');
      if (img && mock && img.getAttribute('src') !== mock) {
        if (!img.hasAttribute('data-sds-orig-src')) {
          img.setAttribute('data-sds-orig-src', img.getAttribute('src') || '');
          if (img.getAttribute('srcset')) img.setAttribute('data-sds-orig-srcset', img.getAttribute('srcset'));
        }
        img.removeAttribute('srcset');
        img.setAttribute('src', mock);
        img.style.objectFit = 'contain';
      }

      var chip = row.querySelector('.sds-dfee');
      if (!fees.length) { if (chip) chip.remove(); return; }
      var html = feeHtml(it, fees, cart.currency);
      if (!chip) {
        var at = feeAnchor(row);
        if (!at) return;
        chip = document.createElement('div');
        chip.className = 'sds-dfee';
        if (at.after) at.node.parentNode.insertBefore(chip, at.node.nextSibling);
        else at.node.parentNode.insertBefore(chip, at.node);
      }
      if (chip.__html !== html) { chip.innerHTML = html; chip.__html = html; }
    });
  }

  function cardHtml(pid, lines, cart) {
    var count = 0, total = 0, orig = 0;
    lines.forEach(function (it) {
      count += it.quantity;
      total += it.final_line_price;
      orig += it.original_line_price;
    });
    var shown = lines.slice(0, 7);
    var thumbs = shown.map(function (it) {
      return '<li><img src="' + esc(thumb(it.image)) + '" alt="" loading="lazy" width="38" height="38">' +
        (it.quantity > 1 ? '<span class="sds-dpack__qty">x' + it.quantity + '</span>' : '') + '</li>';
    }).join('');
    if (lines.length > shown.length) thumbs += '<li class="sds-dpack__more">+' + (lines.length - shown.length) + '</li>';
    var save = orig - total;
    var isOpen = !!expanded[pid];
    return '' +
      '<div class="sds-dpack__top">' +
        '<div>' +
          '<span class="sds-dpack__tag">Bundle</span>' +
          '<h3 class="sds-dpack__title">Custom ' + count + '-Pack</h3>' +
          '<p class="sds-dpack__meta">#' + esc(pid) + ' &middot; ' + count + (count === 1 ? ' shirt' : ' shirts') + '</p>' +
        '</div>' +
        '<p class="sds-dpack__price">' +
          (save > 0 ? '<s><span class="sds-sr" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Original price </span>' + money(orig, cart.currency) + '</s>' : '') +
          '<strong>' + money(total, cart.currency) + '</strong>' +
          (save > 0 ? '<span class="sds-dpack__save">Save ' + money(save, cart.currency) + '</span>' : '') +
        '</p>' +
      '</div>' +
      '<ul class="sds-dpack__thumbs" aria-hidden="true">' + thumbs + '</ul>' +
      '<div class="sds-dpack__acts">' +
        '<a href="' + BUILDER + '?edit=' + encodeURIComponent(pid) + '">Edit in builder</a>' +
        '<button type="button" data-sds-toggle aria-expanded="' + isOpen + '">' + (isOpen ? 'Hide shirts' : 'Show shirts') + '</button>' +
        '<button type="button" data-sds-remove' + (armed[pid] ? ' data-armed' : '') + '>' + (armed[pid] ? 'Tap again to remove' : 'Remove bundle') + '</button>' +
      '</div>';
  }

  function render() {
    var r = root();
    if (!r) return;
    var rows = Array.prototype.slice.call(r.querySelectorAll('.upcart-product-item[id]'));
    if (!rows.length) {
      pause(function () { clearAll(r); });
      return;
    }
    var need = !cartCache || rows.some(function (row) {
      return !cartCache.items.some(function (it) { return it.key === row.id; });
    });
    var ready = need ? api('/cart.js').then(function (c) { cartCache = c; return c; }) : Promise.resolve(cartCache);
    ready.then(function (cart) {
      pause(function () { draw(r, rows, cart); });
    }).catch(function () {
      pause(function () { clearAll(r); });
    });
  }

  function draw(r, rows, cart) {
    try {
      if (!r.querySelector('style[data-sds-pack]')) {
        var st = document.createElement('style');
        st.setAttribute('data-sds-pack', '');
        st.textContent = CSS;
        r.appendChild(st);
      }
      var byKey = {};
      cart.items.forEach(function (it) { byKey[it.key] = it; });
      var groups = {}, order = [];
      rows.forEach(function (row) {
        var it = byKey[row.id];
        var pid = packId(it);
        if (!pid) {
          row.removeAttribute('data-sds-hide');
          row.removeAttribute('data-sds-pack-row');
          return;
        }
        if (!groups[pid]) { groups[pid] = { rows: [], lines: [] }; order.push(pid); }
        groups[pid].rows.push(row);
        groups[pid].lines.push(it);
      });

      r.querySelectorAll('.sds-dpack').forEach(function (card) {
        if (!groups[card.getAttribute('data-sds-pack')]) card.remove();
      });

      order.forEach(function (pid) {
        var g = groups[pid];
        var first = g.rows[0];
        var card = r.querySelector('.sds-dpack[data-sds-pack="' + pid + '"]');
        if (!card) {
          card = document.createElement('div');
          card.className = 'sds-dpack';
          card.setAttribute('data-sds-pack', pid);
          card.setAttribute('role', 'group');
          card.addEventListener('click', onCardClick);
        }
        var html = cardHtml(pid, g.lines, cart);
        if (card.__html !== html) {
          var focused = r.activeElement && card.contains(r.activeElement) ? (r.activeElement.hasAttribute('data-sds-toggle') ? '[data-sds-toggle]' : r.activeElement.hasAttribute('data-sds-remove') ? '[data-sds-remove]' : null) : null;
          card.innerHTML = html;
          card.__html = html;
          if (focused) { var f = card.querySelector(focused); if (f) f.focus(); }
        }
        card.setAttribute('aria-label', 'Bundle ' + pid);
        if (first.previousElementSibling !== card) first.parentNode.insertBefore(card, first);
        g.rows.forEach(function (row) {
          row.setAttribute('data-sds-pack-row', pid);
          if (expanded[pid]) { row.removeAttribute('data-sds-hide'); row.setAttribute('data-sds-open', ''); }
          else { row.setAttribute('data-sds-hide', ''); row.removeAttribute('data-sds-open'); }
        });
      });

      try { drawFees(r, rows, cart, byKey); } catch (e) { clearFees(r); }
    } catch (e) {
      clearAll(r);
    }
  }

  function onCardClick(e) {
    var card = e.currentTarget;
    var pid = card.getAttribute('data-sds-pack');
    var t = e.target.closest('button');
    if (!t) return;
    if (t.hasAttribute('data-sds-toggle')) {
      expanded[pid] = !expanded[pid];
      scheduleRender(0);
      return;
    }
    if (t.hasAttribute('data-sds-remove')) {
      if (!armed[pid]) {
        armed[pid] = true;
        scheduleRender(0);
        setTimeout(function () { if (armed[pid] === true) { delete armed[pid]; scheduleRender(0); } }, 4000);
        return;
      }
      armed[pid] = 'busy';
      t.disabled = true;
      t.textContent = 'Removing...';
      api('/cart.js').then(function (cart) {
        var updates = {};
        cart.items.forEach(function (it) { if (packId(it) === pid) updates[it.key] = 0; });
        return api('/cart/update.js', { updates: updates });
      }).catch(function () {}).then(function () {
        delete armed[pid];
        delete expanded[pid];
        cartCache = null;
        refreshDrawer();
        var focusTarget = root() && root().querySelector('[aria-label="Close cart"]');
        if (focusTarget) focusTarget.focus();
      });
    }
  }

  function pause(fn) {
    if (observer) observer.disconnect();
    try { fn(); } finally {
      if (observer && observedRoot) observer.observe(observedRoot, { childList: true, subtree: true });
    }
  }

  function scheduleRender(ms) {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(render, ms == null ? 120 : ms);
  }

  function attach() {
    var r = root();
    if (!r || r === observedRoot) return;
    observedRoot = r;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () { scheduleRender(); });
    observer.observe(r, { childList: true, subtree: true });
    scheduleRender(0);
  }

  attach();
  var tries = 0;
  var poll = setInterval(function () {
    attach();
    if (++tries > 120) clearInterval(poll);
  }, 500);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) attach(); });

  scheduleRelabel();
})();
